import Vue from 'vue';
import constants from '../../../../constants';

export default {
  methods: {
    showNotification({ type, title, message }) {
      const text = message || (type === 'error' ? this.$translate(constants.DEFAULT_ERROR_MESSAGE) : '');
      const notificationTitle = title || (type === 'error' ? this.$translate(constants.DEFAULT_ERROR_TITLE) : '');
      Vue.notify({
        group: 'app',
        title: notificationTitle,
        type,
        text,
      });
    },
  },
};
